import axios from "axios";

export default {
    update(data) {
        return axios({
            method: "put",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/patientWelcome",
            data: data,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAll() {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/patientWelcome",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    testEmail() {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/patientWelcome/email/test",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
};
